import { z } from 'zod';
import { DeliveryArticleCategoryModelSchema } from 'entities/delivery-article-category';
import { GetDeliveryArticleTagsApiResponseSchema } from '../store';

export const createDeliveryArticleTagsFromGetDeliveryArticleTagsApiResponse = (
    (response: z.infer< typeof GetDeliveryArticleTagsApiResponseSchema>) => (
        response.data.map(({
            slug,
            name,

        }) => DeliveryArticleCategoryModelSchema.parse({
            uid: slug,
            name,
        }))
    )
);
